export const DRAFT_FIELDS = [
  "issue", "description", "equipment", "assignTo", "priority", "workorder_type",
  "recommended_action", "reportBy", "due_date", "status",
];

export const sameDraftScope = (scope, companyId, facilityId) => Boolean(
  scope && companyId && facilityId &&
  String(scope.company_id) === String(companyId) &&
  String(scope.facility_id) === String(facilityId)
);

export const fieldValue = (value) => (
  value && typeof value.format === "function" ? value.format("YYYY-MM-DD") : value
);

// Only fill empty fields or replace an unchanged value from the previous draft.
// A field edited while the request was running must also be preserved.
export const draftValuesToApply = ({ draft, companyId, facilityId, current, snapshot, previous = {} }) => {
  if (draft?.saved !== false || !sameDraftScope(draft?.scope, companyId, facilityId)) {
    throw new Error("This draft belongs to a different facility. Please generate it again.");
  }
  const values = {};
  for (const key of DRAFT_FIELDS) {
    const candidate = draft.values?.[key];
    if (candidate === undefined || candidate === null || candidate === "") continue;
    if (["equipment", "assignTo"].includes(key) && (!Number.isInteger(candidate) || candidate <= 0)) continue;
    if (!["equipment", "assignTo"].includes(key) && typeof candidate !== "string") continue;
    const existing = fieldValue(current[key]);
    if (existing !== fieldValue(snapshot[key])) continue;
    const empty = existing === undefined || existing === null || existing === "";
    if (empty || (key in previous && existing === fieldValue(previous[key]))) values[key] = candidate;
  }
  return values;
};
